<div
  [ngClass]="{
    'interface-control__suspend__container': true,
    'interface-control__suspend__container--valid': data.state === 0 && !data.locked,
    'interface-control__suspend__container--invalid': data.state === 1 && !data.locked,
    'interface-control__suspend__container--active': data.state === 2 && !data.locked,
    'interface-control__suspend__container--inactive': data.state == 3 && !data.locked,
    'interface-control__suspend__container--locked': data.locked
  }"
>
  <div
    [bfx-input]="bfxInput"
    [ngClass]="inputDirective.classes"
    #input
    [attr.tabindex]="data.checkbox.locked ? -1 : 0"
    (focus)="onCheckboxFocus($event)"
    (blur)="onCheckboxBlur($event)"
    (keydown)="onKeydown($event)"
  >
    <div class="bfx-input-label">
      <p-checkbox
        #chkBox
        [bfxInputLabelOnClick]="chkBoxLabel"
        [ngClass]="{
                'bfx-checkbox-enable-control': true,
                'interface-control__suspend__checkbox': true,
                'interface-control__suspend__checkbox--checked': data.checkbox.value && !data.checkbox.locked,
                'interface-control__suspend__checkbox--unchecked': !data.checkbox.value && !data.checkbox.locked,
                'interface-control__suspend__checkbox--locked': data.checkbox.locked}"
        binary="true"
        [disabled]="data.checkbox.locked"
        [(ngModel)]="data.checkbox.value"
        (onChange)="onSuspendCheckboxChange()"
        tabindex="-1"
      >
      </p-checkbox>
      <div
        #chkBoxLabel
        [ngClass]="inputDirective.labelClasses"
        class="interface-control__suspend__label"
      >
        {{ data.checkbox.label }}
      </div>
    </div>
  </div>
  <div
    #inputs
    class="interface-control__suspend__time-inputs"
    [style.display]="!data.checkbox.value ? 'none': 'flex'"
  >
    <bfx-time-input
      #inputSuspendFrom
      [suspend]="true"
      [adjustDropdownDir]="true"
      [(ngModel)]="data.from.value"
      [externalState]="data.from.externalState"
      (blur)="onSuspendFromBlur($event)"
    >
    </bfx-time-input>
    <bfx-time-input
      #inputSuspendTo
      [suspend]="true"
      [adjustDropdownDir]="true"
      [(ngModel)]="data.to.value"
      [externalState]="data.to.externalState"
      (blur)="onSuspendToBlur($event)"
    >
    </bfx-time-input>
  </div>
</div>
